import { PropsWithChildren } from 'react'
import Categories from './Categories'
import CollectivePageHeader from '../Common/CollectivePageHeader/CollectivePageHeader'
import { useCollectiveContext } from 'context/CollectiveContext'
import ContentWrapper from 'components/ContentWrapper'

const ForumWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  const { collective } = useCollectiveContext()

  return (
    <ContentWrapper>
      <div className="min-h-screen-minus-navbar flex flex-col">
        <CollectivePageHeader collective={collective} />

        <div className="px-4 flex-1 flex gap-4">
          <Categories />

          <div className="space-y-4 flex-1">{children}</div>
        </div>
      </div>
    </ContentWrapper>
  )
}

export default ForumWrapper
